import React from 'react';
import PropTypes from 'prop-types';

import styles from './codeWrapper.scss';

import RuntimeErrorCaptions from './RuntimeErrorCaptions';
import OutcomeIcon from './../../../interactionOutcome/OutcomeIcon';
import stringUtils from '../../../../../qti/utils/StringUtils';
import { t } from '../../../../../services/i18nService';
import extendedTextCodeA11ySelector from '../../../../../selectors/question/interactions/extendedTextInteraction/code/ExtendedTextCodeA11ySelector';
import a11yIIBScreenReaderService from '../../../../../services/a11yIIBScreenReaderService';

class ExtendedTextCodeCompilerTestCases extends React.Component {
    static propTypes = {
        mode: PropTypes.string.isRequired,
        testCases: PropTypes.array,
        testCasesResults: PropTypes.array,
    };

    codeCompilerSamplesTHead = () => {
        const { mode } = this.props;

        return (
            <tr className="test-cases-head">
                <th>
                    {t('codeCompiler.testCaseNo')}
                </th>
                <th>
                    {t('codeCompiler.testCaseInput')}
                </th>
                <th>
                    {t('codeCompiler.testCaseOutput')}
                </th>
                {mode === 'results' || mode === 'results_eval' ?
                    <React.Fragment>
                        <th>{t('codeCompiler.testCaseStatus')}</th>
                        <th>{t('codeCompiler.testCaseTime')}</th>
                    </React.Fragment>
                    : null
                }
            </tr>
        );
    };

    returnRunTimeSignalText = (signal) => {
        let runtimeError;
        if (signal === '11') {
            runtimeError = RuntimeErrorCaptions.SIGSEGV;
        } else if (signal === '25') {
            runtimeError = RuntimeErrorCaptions.SIGXFSZ;
        } else if (signal === '8') {
            runtimeError = RuntimeErrorCaptions.SIGFPE;
        } else if (signal === '6') {
            runtimeError = RuntimeErrorCaptions.SIGABRT;
        } else {
            runtimeError = RuntimeErrorCaptions.OTHER;
        }
        return (
            <div className={styles.runtimeError}>
                {runtimeError}
            </div>
        );
    };

    returnResponseText = (testCase) => {
        if (testCase.status_code === 'AC') { // AC - accepted
            return t('codeCompiler.correct');
        }

        let wrongText = t('codeCompiler.wrong');
        switch (testCase.status_code) {
        case 'RE': // RE - runtime error
        case 'TLE': // TLE - time limit exceeded
        case 'CE': // CE - compilation error
            wrongText += `: ${testCase.status}`;
            break;
        default: // WA - wrong answer
            break;
        }

        return wrongText;
    };

    codeCompilerSamplesTBody = () => {
        const { mode, testCases, testCasesResults } = this.props;

        if (testCases.length < 1) {
            return (
                <tr>
                    <td colSpan={20}>-</td>
                </tr>
            );
        }
        return testCases.map((row, index) => {
            const id = stringUtils.getUID();
            const result = testCasesResults ? testCasesResults[index] : undefined;

            return (
                <tr key={`tr_${id}`} className="test-case">
                    <td key={`td_no_${id}`}>
                        {index + 1}
                    </td>
                    <td key={`td_input_${id}`}>
                        {typeof row.expectedInput === 'object' ? JSON.stringify(row.expectedInput) : row.expectedInput}
                    </td>
                    <td key={`td_output_${id}`}>
                        {typeof row.expectedOutput === 'object' ? JSON.stringify(row.expectedOutput) : row.expectedOutput}
                    </td>
                    {(mode === 'results' || mode === 'results_eval') && result ?
                        <React.Fragment>
                            <td key={`td_status-${id}`}>
                                <OutcomeIcon isAttempted isCorrect={result.status_code === 'AC'} />
                                {this.returnResponseText(result)}
                                {result.status_code === 'RE' ?
                                    this.returnRunTimeSignalText(result.signal)
                                    : null
                                }
                            </td>
                            <td key={`td_time_${id}`}>
                                {`${result.time}s`}
                            </td>
                        </React.Fragment>
                        : null
                    }
                </tr>
            );
        });
    };

    render() {
        const testCasesTableA11yAttributes = extendedTextCodeA11ySelector.getTestCasesTableA11yAttributes();
        const tabIndexValue = a11yIIBScreenReaderService.getTabIndexValue(undefined);

        return (
            <table
                className={styles.samples}
                {...testCasesTableA11yAttributes}
                tabIndex={tabIndexValue}
            >
                <thead>
                    {this.codeCompilerSamplesTHead()}
                </thead>
                <tbody>
                    {this.codeCompilerSamplesTBody()}
                </tbody>
            </table>
        );
    }
}

export default ExtendedTextCodeCompilerTestCases;
